import React from 'react';
import { InputSection, Label, Input } from './style';

const LoginIdInputSection = ({ userId, setUserId }) => {
    return (
        <InputSection>
            <Label htmlFor="userId">아이디</Label>
            <Input
                type="text"
                id="userId"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="아이디를 입력하세요"
            />
        </InputSection>
    );
};

export default LoginIdInputSection;
